import { QueryObserverOptions, useQuery } from 'react-query';

import { get } from 'lodash';

import axiosClient from '@lib/utils/axiosClient';

import { ManyEndpointPostfix, Params, ResourceKeys } from '../types';

async function fetchEntityMany<EntityName extends string, EntityMany>(
  entity: EntityName,
  params: Params,
  postFix: ManyEndpointPostfix,
) {
  const response = await axiosClient.get<EntityMany>(`/${entity}${postFix}`, { params });
  return get(response.data, 'response') || response.data;
}

export function useEntityMany<EntityMany>(
  keys: ResourceKeys['many'],
  postFix: ManyEndpointPostfix,
  params: Params,
  options?: QueryObserverOptions<EntityMany>,
) {
  const entityKeys = keys(params);
  const [entityName] = entityKeys;
  return useQuery<EntityMany>(entityKeys, () => fetchEntityMany(entityName as any, params, postFix), options);
}
